/** 报备功能开关 */
export const ENABLE_ORDER_REPORT = true;

export function isOrderReportEnabled() {
    return !!ENABLE_ORDER_REPORT;
}

/**
 * 报备按钮显示规则
 * @param {Object} orderInfo 订单信息
 * @param {String} scene 场景：goToRescue | orderProcess | driver
 */
export function isShowReportBtn(orderInfo, scene = 'driver') {
    if (!isOrderReportEnabled()) {
        return false;
    }
    if (!orderInfo) {
        return false;
    }
    if (orderInfo.cancel_waiting == 1 || orderInfo.cancel_waiting == 2) {
        return false;
    }
    const status = Number(orderInfo.status);
    if (scene === 'goToRescue') {
        return status === 2 || status === 22 || status === 23;
    }
    if (scene === 'orderProcess') {
        return status === 24 || status === 3 || status === 25 || status === 26;
    }
    // H5 做单页：已接单及之后的进行中状态均可报备
    if (scene === 'driver') {
        return status === 2 || status === 11 || status === 22 || status === 23
            || status === 24 || status === 3 || status === 25 || status === 26;
    }
    return false;
}

export function calcReportUnreadCount(list) {
    return (list || []).reduce((sum, item) => {
        if (Number(item.is_done) === 1) {
            return sum;
        }
        return sum + (Number(item.unread) || 0);
    }, 0);
}

export function hasPendingReport(list) {
    return (list || []).some((item) => Number(item.is_done) !== 1);
}

export function buildReportSummary(list) {
    const normalized = list || [];
    return {
        unread: calcReportUnreadCount(normalized),
        has_pending: hasPendingReport(normalized),
        fingerprint: normalized.map((item) => `${item.id}:${item.unread}:${item.is_done}`).join('|')
    };
}
